/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import {
  getDatasources,
  setOutputs,
  setInputs
} from '@redux/actions/FinancialModelActions';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import clsx from 'clsx';

import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';

import InputControlled from './InputControlled';

const StyledTableHead = withStyles((theme) => ({
  root: {
    display: 'none'
  }
}))(TableHead);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    borderBottom: 'none !important',
    fontSize: 12
  }
}))(TableCell);

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    fontWeight: 'bold'
  },
  body: {
    fontSize: 12,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const TableCellTitleStrong = withStyles((theme) => ({
  body: {
    fontSize: 14,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const TableCellTitle = withStyles((theme) => ({
  body: {
    fontSize: 14,
    borderBottom: 'none !important',
    '& span': {
      color: '#ff9800'
    }
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(14,78,173,0.05)'
  }
}))(TableRow);

const NetTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(14,78,173,0.2)'
  }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700
  },
  tableContainer: {
    borderTop: '5px solid #2DB9C4'
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',

    '& p': {
      marginLeft: 20,
      fontSize: 12
    },
    '& h2': {
      fontSize: 20,
      fontWeight: 'bold'
    }
  },
  input: {
    color: '#002380',
    maxWidth: 75,
    width: 75,
    minHeight: 30,
    padding: 10,
    textAlign: 'center',
    border: '2px solid #002380',
    borderRadius: '5px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  percentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& span': {
      marginLeft: 2,
      color: '#002380',
      fontWeight: 600
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    padding: 30,
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    '& p': {
      fontSize: 14,
      color: '#001E41'
    },
    '& svg': {
      color: '#001E41'
    }
  },
  expandOpen: {
    '& svg': {
      transform: 'rotate(180deg)'
    }
  },
  loader: {
    flex: 1,
    textAlign: 'right'
  },
  expandIconContainer: {
    display: 'flex',
    justifyContent: 'right',
    '& > button.MuiIconButton-root:hover': {
      backgroundColor: 'unset'
    }
  }
}));

function MergeObj(original, newobject) {
  for (const [key, value] of Object.entries(newobject)) {
    Object.keys(value).map((subkey) => (original[key][subkey] = value[subkey]));
  }
  return original;
}

const TableIncome = ({ scenario }) => {
  const dispatch = useDispatch();
  const outputs = useSelector((state) => state.FinancialModelReducer.outputs);
  const inputs = useSelector((state) => state.FinancialModelReducer.inputs);

  const isLoadingz = useSelector(
    (state) => state.FinancialModelReducer.loading
  );
  const errorScenarios = useSelector(
    (state) => state.FinancialModelReducer.error
  );

  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [inputsToSend, setInputsToSend] = useState({});

  const classes = useStyles();

  useEffect(() => {
    dispatch(getDatasources());
    setState(inputs);
  }, [inputs]);

  const handleChangeInput = ({ target: { name, value } }) => {
    if (value.length <= 0) {
      setState({ ...state, [name]: null });
      setInputsToSend({ [name]: null });
    } else {
      setState({ ...state, [name]: Number(value) });
      setInputsToSend({ [name]: Number(value) });
    }
  };

  const handleKeyPress = async (e) => {
    if (e.key === 'Enter') {
      try {
        setLoading(true);
        const {
          data: { data }
        } = await axios.put(
          `http://drivee.localhost/api/fmodel/scenarios/${scenario.id}`,
          { input_object: inputsToSend }
        );

        dispatch(setOutputs(MergeObj(outputs, data.outputs)));
        dispatch(setInputs({ ...inputs, ...inputsToSend }));
        setInputsToSend({});
        setLoading(false);
        return data;
      } catch (error) {
        setLoading(false);
        console.log('ERROOORRR', error);
      }
    }
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      {errorScenarios && (
        <p style={{ margin: 15, color: 'red', fontStyle: 'italic' }}>
          {errorScenarios}
        </p>
      )}
      <div className={classes.header}>
        <h2>Income statement</h2>
        <p>
          As of year end 31/12, all figures in EURm (except otherwise stated)
        </p>
        <div className={classes.loader}>
          {loading || (isLoadingz && <CircularProgress size={20} />)}
        </div>
      </div>

      <Table
        aria-label="customized table"
        className={classes.table}
        size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellStrong />
            <StyledTableCellStrong align="center">2019</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2020E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2021E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2022E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2023E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2024E</StyledTableCellStrong>
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <TableCellTitleStrong>Group revenues</TableCellTitleStrong>
            {Object.values(outputs.group_revenues)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </StyledTableRow>
          <TableRow>
            <TableCellTitle>Change y/y </TableCellTitle>
            <StyledTableCell align="center">
              {outputs.change_y_y._0}
            </StyledTableCell>
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="change_y_y_1"
              placeholder={
                inputsToSend.change_y_y_1 === null
                  ? null
                  : outputs.change_y_y._1
              }
              value={state.change_y_y_1}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="change_y_y_2"
              placeholder={
                inputsToSend.change_y_y_2 === null
                  ? null
                  : outputs.change_y_y._2
              }
              value={state.change_y_y_2}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="change_y_y_3"
              placeholder={
                inputsToSend.change_y_y_3 === null
                  ? null
                  : outputs.change_y_y._3
              }
              value={state.change_y_y_3}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="change_y_y_4"
              placeholder={
                inputsToSend.change_y_y_4 === null
                  ? null
                  : outputs.change_y_y._4
              }
              value={state.change_y_y_4}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="change_y_y_5"
              placeholder={
                inputsToSend.change_y_y_5 === null
                  ? null
                  : outputs.change_y_y._5
              }
              value={state.change_y_y_5}
            />
          </TableRow>
          <TableRow>
            <TableCellTitle>Gross profit</TableCellTitle>
            {Object.values(outputs.gross_profit)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Gross margin</TableCellTitle>
            {Object.values(outputs.gross_margin)
              .slice(1, 2)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="gross_margin_1"
              placeholder={
                inputsToSend.gross_margin_1 === null
                  ? null
                  : outputs.gross_margin._1
              }
              value={state.gross_margin_1}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="gross_margin_2"
              placeholder={
                inputsToSend.gross_margin_2 === null
                  ? null
                  : outputs.gross_margin._2
              }
              value={state.gross_margin_2}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="gross_margin_3"
              placeholder={
                inputsToSend.gross_margin_3 === null
                  ? null
                  : outputs.gross_margin._3
              }
              value={state.gross_margin_3}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="gross_margin_4"
              placeholder={
                inputsToSend.gross_margin_4 === null
                  ? null
                  : outputs.gross_margin._4
              }
              value={state.gross_margin_4}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="gross_margin_5"
              placeholder={
                inputsToSend.gross_margin_5 === null
                  ? null
                  : outputs.gross_margin._5
              }
              value={state.gross_margin_5}
            />
          </TableRow>
          <StyledTableRow>
            <TableCellTitleStrong>EBITDA</TableCellTitleStrong>
            {Object.values(outputs.ebitda)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </StyledTableRow>
          <TableRow>
            <TableCellTitle>EBITDA margin</TableCellTitle>
            {Object.values(outputs.ebitda_margin)
              .slice(1, 2)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="ebitda_margin_1"
              placeholder={
                inputsToSend.ebitda_margin_1 === null
                  ? null
                  : outputs.ebitda_margin._1
              }
              value={state.ebitda_margin_1}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="ebitda_margin_2"
              placeholder={
                inputsToSend.ebitda_margin_2 === null
                  ? null
                  : outputs.ebitda_margin._2
              }
              value={state.ebitda_margin_2}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="ebitda_margin_3"
              placeholder={
                inputsToSend.ebitda_margin_3 === null
                  ? null
                  : outputs.ebitda_margin._3
              }
              value={state.ebitda_margin_3}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="ebitda_margin_4"
              placeholder={
                inputsToSend.ebitda_margin_4 === null
                  ? null
                  : outputs.ebitda_margin._4
              }
              value={state.ebitda_margin_4}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="ebitda_margin_5"
              placeholder={
                inputsToSend.ebitda_margin_5 === null
                  ? null
                  : outputs.ebitda_margin._5
              }
              value={state.ebitda_margin_5}
            />
          </TableRow>
          <TableRow>
            <TableCellTitle>Depr & amort (-)</TableCellTitle>
            {Object.values(outputs.depr_amort)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Depr & amort as % of revenues</TableCellTitle>
            {Object.values(outputs.depr_amort_p)
              .slice(1, 2)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="depr_amort_p_1"
              placeholder={
                inputsToSend.depr_amort_p_1 === null
                  ? null
                  : outputs.depr_amort_p._1
              }
              value={state.depr_amort_p_1}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="depr_amort_p_2"
              placeholder={
                inputsToSend.depr_amort_p_2 === null
                  ? null
                  : outputs.depr_amort_p._2
              }
              value={state.depr_amort_p_2}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="depr_amort_p_3"
              placeholder={
                inputsToSend.depr_amort_p_3 === null
                  ? null
                  : outputs.depr_amort_p._3
              }
              value={state.depr_amort_p_3}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="depr_amort_p_4"
              placeholder={
                inputsToSend.depr_amort_p_4 === null
                  ? null
                  : outputs.depr_amort_p._4
              }
              value={state.depr_amort_p_4}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="depr_amort_p_5"
              placeholder={
                inputsToSend.depr_amort_p_5 === null
                  ? null
                  : outputs.depr_amort_p._5
              }
              value={state.depr_amort_p_5}
            />
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Total unusual items <span>(+ income / - charge)</span>
            </TableCellTitle>
            {Object.values(outputs.total_unusual)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <StyledTableRow>
            <TableCellTitleStrong>Operating profit</TableCellTitleStrong>
            {Object.values(outputs.operating_profit)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </StyledTableRow>
          <TableRow>
            <TableCellTitle>Operating profit margin</TableCellTitle>
            {Object.values(outputs.operating_profit_margin)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Net interest <span>(+ income / - charge)</span>
            </TableCellTitle>
            {Object.values(outputs.net_interest)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Interest expenses (-)</TableCellTitle>
            {Object.values(outputs.interest_exp)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Interest rate</TableCellTitle>
            {Object.values(outputs.interest_rate)
              .slice(1, 2)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="interest_rate_1"
              placeholder={
                inputsToSend.interest_rate_1 === null
                  ? null
                  : outputs.interest_rate._1
              }
              value={state.interest_rate_1}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="interest_rate_2"
              placeholder={
                inputsToSend.interest_rate_2 === null
                  ? null
                  : outputs.interest_rate._2
              }
              value={state.interest_rate_2}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="interest_rate_3"
              placeholder={
                inputsToSend.interest_rate_3 === null
                  ? null
                  : outputs.interest_rate._3
              }
              value={state.interest_rate_3}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="interest_rate_4"
              placeholder={
                inputsToSend.interest_rate_4 === null
                  ? null
                  : outputs.interest_rate._4
              }
              value={state.interest_rate_4}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="interest_rate_5"
              placeholder={
                inputsToSend.interest_rate_5 === null
                  ? null
                  : outputs.interest_rate._5
              }
              value={state.interest_rate_5}
            />
          </TableRow>
          <TableRow>
            <TableCellTitle>Interest and invest income (+)</TableCellTitle>
            {Object.values(outputs.interest_invest_income)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
        </TableBody>
      </Table>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Table className={classes.table} size="small">
          <StyledTableHead>
            <TableRow>
              <StyledTableCellStrong />
              <StyledTableCellStrong align="center" />
              <StyledTableCellStrong align="center" />
              <StyledTableCellStrong align="center" />
              <StyledTableCellStrong align="center" />
              <StyledTableCellStrong align="center" />
              <StyledTableCellStrong align="center" />
            </TableRow>
          </StyledTableHead>
          <TableBody>
            <StyledTableRow>
              <TableCellTitleStrong>PBT</TableCellTitleStrong>
              {Object.values(outputs.pbt)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </StyledTableRow>
            <TableRow>
              <TableCellTitle>Tax charge, as reported (-)</TableCellTitle>
              {Object.values(outputs.tax_charge)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>Tax rate</TableCellTitle>
              {Object.values(outputs.tax_rate)
                .slice(1, 2)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="tax_rate_1"
                placeholder={
                  inputsToSend.tax_rate_1 === null ? null : outputs.tax_rate._1
                }
                value={state.tax_rate_1}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="tax_rate_2"
                placeholder={
                  inputsToSend.tax_rate_2 === null ? null : outputs.tax_rate._2
                }
                value={state.tax_rate_2}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="tax_rate_3"
                placeholder={
                  inputsToSend.tax_rate_3 === null ? null : outputs.tax_rate._3
                }
                value={state.tax_rate_3}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="tax_rate_4"
                placeholder={
                  inputsToSend.tax_rate_4 === null ? null : outputs.tax_rate._4
                }
                value={state.tax_rate_4}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="tax_rate_5"
                placeholder={
                  inputsToSend.tax_rate_5 === null ? null : outputs.tax_rate._5
                }
                value={state.tax_rate_5}
              />
            </TableRow>
            <TableRow>
              <TableCellTitle>
                Share of profits / loss from associates(+/-)
              </TableCellTitle>
              {Object.values(outputs.share_profit_loss_asso)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>Profit/loss from minorities (-/+)</TableCellTitle>
              {Object.values(outputs.profit_loss_mino)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <NetTableRow>
              <TableCellTitleStrong>Net income</TableCellTitleStrong>
              {Object.values(outputs.net_income)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </NetTableRow>
          </TableBody>
        </Table>
      </Collapse>
      <div className={classes.expandIconContainer}>
        <IconButton
          disableRipple
          aria-expanded={expanded}
          aria-label="show more"
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}>
          <p>{expanded ? 'hide details' : 'expand for more details'}</p>
          <ExpandMoreIcon />
        </IconButton>
      </div>
    </TableContainer>
  );
};

export default TableIncome;
